import { 
  initVerification, 
  verifyTeachers, 
  verifyStudents, 
  verifyFields,
} from './'

/**
 * Verifies that there are no problems with the CSV upload and flags potential errors.
 * Checks for things like typos, merge misses, invalid responses, and missing 
 * mandatory fields.
 * @param {array} uploadData contains student data object with answers, name, etc.
 * @param {object} school the school record, stored in schools collection 
 * @param {string} schoolYear the school year, e.g. '2018'
 * @param {object} assessment the set for the assessment that was taken, stored in assessments collection in db
 * @returns {object} a verification object with warnings and errors for particular rows that uploadData objects came from
 */
export default function verifyUpload (uploadData, school, schoolYear, assessment) {
  // function init: get all of the students, educators, classes, groupUAs, and userAssessments in the school.
  return initVerification(school.id)
    .then(records => {
      const verification = {}
      // VERIFY REQUIRED FIELDS and VERIFY ALLOWED INPUT IN EACH FIELD

      // VERIFY TEACHER USERNAMES
      // aggregate all of the teacher names and check them for potential matches.
      // track what rows involve those teacher names
      // Also, check the aggregated teacher names for closeness. 
      // Are they potentially the same person?
      // teacherWarnings: {rows: Array, warning: String}
      // teacherErrors: {rows: Array, error: String}
      const { teacherWarnings, teacherErrors } = verifyTeachers(uploadData, records)
      verification.teacherWarnings = teacherWarnings
      verification.teacherErrors = teacherErrors
      
      // VERIFY STUDENT USERNAMES
      const { studentWarnings, studentErrors } = verifyStudents(uploadData, records, schoolYear, assessment)
      verification.studentWarnings = studentWarnings
      verification.studentErrors = studentErrors

      // VERIFY INVALID RESPONSES (REQUIRED AND DISALLOWED)
      // Check to see if any required fields are blank 
      // or if a response in a field is not allowed (error)
      const { fieldWarnings, fieldErrors } = verifyFields(uploadData)
      verification.fieldWarnings = fieldWarnings
      verification.fieldErrors = fieldErrors

      return verification
      
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/verifyUpload.js